module.exports = "pegasus_template/assets/styleGroup2-google.png";